import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputLabel from "@mui/material/InputLabel";
import { Icon } from "@iconify/react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Spinner from "react-bootstrap/Spinner";
import Link from "@mui/material/Link";
import Select from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import { Multiselect } from "multiselect-react-dropdown";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Button, IconButton } from "@mui/material";
import settings from "../../helpers/Settings";
import * as moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Cookies from "js-cookie";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Autocomplete from "../AutoCompleteComponent/AutoComplete";
import { esES } from "@mui/x-date-pickers";
let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};


class EditClaimInfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addDiagnosis: false,
      addProcedure: false,
      oralSlected: false,
      allDiagnosis: [],
      procedures: [],
      diagnosisSequence: [],
      informationSequence: [],
      vitalSignsArray: [],
      supportingInfoarray: [],
      elegibilityOffline: false,
      elegibilityOnline: false,
      proceduresForNeedApproval: [],
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      defaultValueClaimFlag: false,
      defaultValuePayerIDFlag: false,
      addBatch: false,
      createRequestModal: false,
      updateClaim: false,
      tabsValue: "1",
      calimDefaultValue: "",
      diagnosisType: "",
      procedureCode: "",
      procedureQuantity: "",
      procedureShare: "",
      procedureDescription: "",
      procedureStatus: "",
      procedureTax: "",
      procedurePrice: "",
      vitalSelect: "",
      vitalValue: "",
      autoCompleteValue: false,
      serviceValue: "",
      toothNumberValue: "",
      packageProcedure: false,
      showToothNumber: false,
      pharmacistSelection: false,
      pharmacistSelectionReasonValue: "",
      attachmentFlag: false,
      selectedClaim:this.props.claimInfo

    };
  }

  componentDidMount = async () => {
    console.log('claimSelected:',this.props.claimInfo)
    this.handleClaimSelect(this.props.claimInfo)
  };
  handleClaimSelect = (claimInfo) => {
    this.setState({
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      selectedPatient: {},
    });

    let {
      allDiagnosisSelect,
      vitalSignSelectArray,
      vitalSignsArray,
    } = this.state;
       
      // let allVitalRows = [];
      let allDiagnosisRows = [];
      let allproceduresRows = [];
      if (claimInfo.supportinginformation &&claimInfo.supportinginformation.length > 0) 
      {
        let categories = claimInfo.supportinginformation;
        for (let i = 0; i < categories.length; i++) {
          let display = Object.keys(categories[i]);
          let valueInfo = Object.values(categories[i]);
          vitalSignSelectArray.push({
            display: display[0] + " " + valueInfo,
            valueInfo: valueInfo,
          });
          vitalSignsArray.push({
            display: display[0],
            valueInfo: valueInfo[0],
            
          });
        }
        console.log(claimInfo.supportinginformation)
        const allVitalRows = claimInfo.supportinginformation.map((element, index) => {
            return (
              <TableRow key={index}>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {Object.keys(element)}{" "}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  {Object.values(element)}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <IconButton
                    onClick={() => {
                      this.handleDeleteVital(index);
                    }}
                  >
                    <Icon color="red" icon="fluent:delete-12-regular" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          }
        );
        this.setState({
          allVitalRows,
          addVitaltotable: true,
          vitalSelected: false,
          supportingInfoarray: claimInfo.supportinginformation,
        });
      } else {
        this.setState({
          vitalSignsArray: [],
          addVitaltotable: false,
          vitalSignSelectArray: [],
          vitalSignJson: "",
        });
      }
      // if (
      //   selectedPatient[0].diagnosis &&
      //   selectedPatient[0].diagnosis.length > 0
      // ) {
      //   let diagnosis = selectedPatient[0].diagnosis;
      //   for (let i = 0; i < diagnosis.length; i++) {
      //     allDiagnosisSelect.push({
      //       view: diagnosis[i].type + " " + diagnosis[i].code,
      //     });
      //   }
      //   allDiagnosisRows = selectedPatient[0].diagnosis.map(
      //     (element, index) => {
      //       return (
      //         <TableRow key={index}>
      //           {selectedPatient[0].claimtype === "institutional" ? (
      //             <>
      //               <TableCell align="center" style={{ fontSize: "small" }}>
      //                 <Checkbox
      //                   name="onAdmission"
      //                   onChange={(e) => this.handleCheckBox(e, index)}
      //                 />{" "}
      //               </TableCell>
      //             </>
      //           ) : null}
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.type}{" "}
      //           </TableCell>
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.code}
      //           </TableCell>
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             <IconButton
      //               onClick={() => {
      //                 this.handleDeleteDiagnosis(index);
      //               }}
      //             >
      //               <Icon color="red" icon="fluent:delete-12-regular" />
      //             </IconButton>
      //           </TableCell>
      //         </TableRow>
      //       );
      //     }
      //   );
      //   this.setState({
      //     allDiagnosisRows,
      //     addDiagnosistotable: true,
      //     allDiagnosis: selectedPatient[0].diagnosis,
      //   });
      // } else {
      //   this.setState({
      //     addDiagnosistotable: false,
      //     diagnosis: "",
      //     allDiagnosis: [],
      //     allDiagnosisSelect: [],
      //   });
      // }
      // if (
      //   selectedPatient[0].allprocedures &&
      //   selectedPatient[0].allprocedures.length
      // ) {
      //   /*  allproceduresRows = selectedPatient[0].allprocedures.map(
      //     (element, index) => {
      //       return (
      //         <TableRow key={index}>
      //           <TableCell align="center">
      //             <Checkbox
      //               name="online"
      //               defaultChecked={
      //                 needAapproval.includes(index + 1) ? true : false
      //               }
      //               onChange={(e) => this.handleCheckBox(e, index)}
      //             />
      //           </TableCell>
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.type}{" "}
      //           </TableCell>
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.code}{" "}
      //           </TableCell>
      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.quantity}
      //           </TableCell>

      //           <TableCell align="center" style={{ fontSize: "small" }}>
      //             {element.description}
      //           </TableCell>
      //           {this.state.showToothNumber ? (
      //             <>
      //               {" "}
      //               <TableCell align="center" style={{ fontSize: "small" }}>
      //                 {element.toothDescription}
      //               </TableCell>
      //               <TableCell align="center" style={{ fontSize: "small" }}>
      //                 <IconButton
      //                   onClick={() => {
      //                     this.handleDeleteProcedure(index);
      //                   }}
      //                 >
      //                   <Icon color="red" icon="fluent:delete-12-regular" />
      //                 </IconButton>
      //               </TableCell>
      //             </>
      //           ) : (
      //             <TableCell align="center" style={{ fontSize: "small" }}>
      //               <IconButton
      //                 onClick={() => {
      //                   this.handleDeleteProcedure(index);
      //                 }}
      //               >
      //                 <Icon color="red" icon="fluent:delete-12-regular" />
      //               </IconButton>
      //             </TableCell>
      //           )}
      //         </TableRow>
      //       );
      //     }
      //   ); */
      //   this.setState({
      //     // allproceduresRows,
      //     addProceduretotable: true,
      //     proceduresForNeedApproval: selectedPatient[0].proceduresneedaproval,
      //     procedures: selectedPatient[0].allprocedures,
      //   });
      // } else {
      //   this.setState({
      //     proceduresForNeedApproval: [],
      //     addProceduretotable: false,
      //     procedure: "",
      //     procedures: [],
      //   });
      // }
      // this.setState({
      //   selectedPatient,
      //   diagnosisSelected: false,
      //   procedureSelected: false,
      //   insuranceSelected: false,
      //   vitalSelected: false,
      //   date,
      //   age,
      // });
     
    
  };
  onFileChange = async (e) => {
    this.setState({ selectedFile: e.target.files[0], fileMsg: "" });
    console.log(e.target.files[0], "file");
    let res = await this.readContent(e.target.files[0]);
    // this.setState({ base64: res });
    this.setState({
      vitalSignJson: { display: "attachment", valueInfo: e.target.files[0], data: res },
      vitalSignSelectJson: {
        display: "attachment" + " " + e.target.files[0].name,
        valueInfo: e.target.files[0].name,
      },
      vitalValue: e.target.files[0].name,
      selectedName: "attachment"
    });

  };
  readContent = async (files) => {
    let fileReader = new FileReader();
    let fileToLoad = files;
    let file = "";
    return new Promise((resolve, reject) => {
      fileReader.onload = async (fileLoadedEvent) => {
        file = fileLoadedEvent.target.result;
        resolve(file.split(",")[1]);
      };
      fileReader.readAsDataURL(fileToLoad);
    });
  };

  getAllDiagnosis = async () => {
    let diagnosisOptions = await axios.put(
      "https://test.kayan-healthcare.com/api/ksa/getAllDiagnosis/",
      {}
    );
    if (diagnosisOptions) {
      let { data } = diagnosisOptions;
      if (data) {
        this.setState({ success: true, allDiagnosisOptions: data });
      } else {
        this.setState({ success: false, loading: true });
      }
    }
  };
  sleep = async (milliseconds) => {
    await new Promise((resolve) => {
      return setTimeout(resolve, milliseconds);
    });
  };

  testSleep = async () => {
    await this.sleep(3000);
    this.setState({ showDiagnosis: true });
  };

  
  handleSubmitAddNewDiagnosis = async (e) => {
    e.preventDefault();
    let { diagnosis, allDiagnosis, allDiagnosisSelect } = this.state;
    this.setState({ autoCompleteValue: true });
    allDiagnosis.push(diagnosis);
    if (!allDiagnosisSelect) {
      for (let i = 0; i < allDiagnosis.length; i++) {
        allDiagnosisSelect.push({
          view: allDiagnosis[i].type + " " + allDiagnosis[i].code,
        });
      }
    } else {
      allDiagnosisSelect.push({ view: diagnosis.type + " " + diagnosis.code });
    }
    const allDiagnosisRows = allDiagnosis.map((element, index) => {
      return (
        <TableRow key={index}>
          {this.state.claimType === "institutional" ? (
            <>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <Checkbox
                  name="onAdmission"
                  onChange={(e) => this.handleCheckBox(e, index)}
                />{" "}
              </TableCell>
            </>
          ) : null}
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.type}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.code}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteDiagnosis(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({
      allDiagnosisRows,
      addDiagnosistotable: true,
      diagnosisType: "",
    });
  };
  handleCloseVital = () => {
    this.setState({ vitalModal: false });
  };
  handleVitalSignModal = () => {
    this.setState({ vitalSignSelected: false, vitalModal: true });
  };
  handleOpenDiagnosis = () => {
    this.setState({ diagnosisModal: true });
    // this.testSleep()
  };
  handleCloseDiagnosis = () => {
    this.setState({ diagnosisModal: false });
  };
  handleCloseCreateRequestModal = () => {
    this.setState({ createRequestModal: false });
  };
  handleOpenProcedure = () => {
    this.setState({
      procedureModal: true,
      incorrectProcedureErrorMessage: "",
    });
  };
  handleCloseProcedure = () => {
    this.setState({ procedureModal: false });
  };

  handleDeleteVital = (index) => {
    let { vitalSignJson, vitalSignsArray, vitalSignSelectArray } = this.state;
    vitalSignsArray.splice(index, 1);
    vitalSignSelectArray.splice(index, 1);
    const allVitalRows = vitalSignsArray.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.display}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.valueInfo}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteVital(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ allVitalRows });
    if (JSON.stringify(vitalSignJson) == "[]") {
      this.setState({ addVitaltotable: false });
    }
  };
  handleDeleteDiagnosis = (index) => {
    let { allDiagnosis, allDiagnosisSelect } = this.state;
    allDiagnosis.splice(index, 1);
    allDiagnosisSelect.splice(index, 1);
    const allDiagnosisRows = allDiagnosis.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.type}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.code}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteDiagnosis(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ allDiagnosisRows });
    if (JSON.stringify(allDiagnosis) == "[]") {
      this.setState({ addDiagnosistotable: false });
    }
  };
  HandleDiagnosisChange = (e) => {
    if (this.state.claimType === "institutional") {
      this.setState({
        diagnosis: {
          ...this.state.diagnosis,
          [e.target.name]: e.target.value,
          onAdmission: false,
        },
        diagnosisType: e.target.value,
      });
    } else {
      this.setState({
        diagnosis: { ...this.state.diagnosis, [e.target.name]: e.target.value },
        diagnosisType: e.target.value,
      });
    }
  };
  handleDiagnosisSelect = (value) => {
    let split = value.split("-");
    let code = split[0];
    let description = split[1];
    console.log(split);
    this.setState({
      diagnosis: {
        ...this.state.diagnosis,
        code: code,
        description: description,
      },
      autoCompleteValue: false,
    });
  };
  HandleInputTextChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({
      [name]: value,
      allDiagnosis: [],
      allDiagnosisRows: [],
      errMsg: "",
      calimDefaultValue: value,
    });
  };

  HandleProcedureChange = (e) => {
    let { informationSequence, diagnosisSequence } = this.state;
    if (e.target.name == "toothNumber") {
      this.setState({ toothNumberValue: e.target.value });
    } else if (e.target.name === "pharmacistSelectionReason") {
      this.setState({ pharmacistSelectionReasonValue: e.target.value });

    }
    if (e.target.name == "type") {
      this.setState({ serviceValue: e.target.value });
      if (e.target.value == "dental") {
        this.setState({ showToothNumber: true });
      } else if (e.target.value == "medication") {
        this.setState({ pharmacistSelection: true });
      } if (e.target.value == "laboratory" || e.target.value == "radiology") {
        this.setState({
          attachmentFlag: true
        })
      }
    }
    if (e.target.name == "tax") {
      this.setState({ procedureTax: e.target.value });
    }
    if (e.target.name == "code") {
      this.setState({ procedureCode: e.target.value });
    }
    if (e.target.name == "quantity") {
      this.setState({ procedureQuantity: e.target.value });
    }
    if (e.target.name == "price") {
      this.setState({ procedurePrice: e.target.value });
    }
    if (e.target.name == "discount") {
      this.setState({ procedureDiscount: e.target.value });
    }
    if (e.target.name == "insuranceStatus") {
      this.setState({ procedureStatus: e.target.value });
    }
    if (e.target.name == "description") {
      this.setState({ procedureDescription: e.target.value });
    }
    if (e.target.name == "tax_percentage") {
      this.setState({ procedureTax: e.target.value });
    }
    if (e.target.name == "patientshare_total") {
      this.setState({ procedureShare: e.target.value });
    }
    if (e.target.name == "toothNumber") {
      let toothNumberInfo = e.target.value.split("-");
      this.setState({
        procedure: {
          ...this.state.procedure,
          toothNumber: toothNumberInfo[0],
          toothDescription: toothNumberInfo[1],
        },
      });
    } else {
      this.setState({
        procedure: {
          ...this.state.procedure,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  HandleVitalSignChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ vitalSelect: value });
    if (value) {
      name = value;
      this.setState({ vitalSignSelected: true, selectedName: value });
      if (value === "chief-complaint") {
        this.setState({
          chiefComplainSelected: true
        })
      } else {
        this.setState({
          chiefComplainSelected: false
        })
      }
      if (value == "attachment") {
        this.setState({ attachmentSelected: true });
      } else {
        this.setState({ attachmentSelected: false });
      }
    } else {
      this.setState({ vitalSignSelected: false });
    }
  };
  handleSubmitAddNewProcedure = async (e) => {
    e.preventDefault();
    let { procedure, procedures, selectedClaim, packageProcedure } = this.state;
    procedure["package"] = packageProcedure
    this.setState({
      incorrectProcedureErrorMessage: "",
      procedureCode: "",
      procedureQuantity: "",
      procedureShare: "",
      procedureDescription: "",
      procedureStatus: "",
      procedureTax: "",
      procedurePrice: "",
      procedureDiscount: "",
      serviceValue: "",
      toothNumberValue: "",
      showToothNumber: false,
      pharmacistSelectionReasonValue: "",
      pharmacistSelection: false,
      attachmentFlag: false
    });

    console.log("procedure", procedure);

    procedures.push(procedure);

    this.setState({
      // packageProcedure: false,
      addProceduretotable: true,
      procedure: {},
    });
  };
  handleCheckBox = async (e, index) => {
    let { procedures, proceduresForNeedApproval, allDiagnosis } = this.state;
    if (e.target.name === "onAdmission") {
      if (e.target.checked) {
        allDiagnosis[index].onAdmission = true;
      }
    } else {
      if (e.target.checked) {
        proceduresForNeedApproval.push(
          procedures.indexOf(procedures[index]) + 1
        );
        console.log(proceduresForNeedApproval);
      } else {
        let i = proceduresForNeedApproval.indexOf(index + 1);
        proceduresForNeedApproval.splice(i, 1);
        console.log(proceduresForNeedApproval);
      }
    }
  };
  handleDeleteProcedure = (index) => {
    let { procedures, proceduresForNeedApproval } = this.state;
    if (proceduresForNeedApproval && proceduresForNeedApproval.length > 0) {
      if (proceduresForNeedApproval.includes(index + 1)) {
        let i = proceduresForNeedApproval.indexOf(index + 1);
        proceduresForNeedApproval.splice(i, 1);
        for (let n = 0; n < proceduresForNeedApproval.length; n++) {
          if (proceduresForNeedApproval[n] > index + 1) {
            proceduresForNeedApproval[n] = proceduresForNeedApproval[n] - 1;
          }
        }
      } else {
        for (let n = 0; n < proceduresForNeedApproval.length; n++) {
          if (proceduresForNeedApproval[n] > index + 1) {
            proceduresForNeedApproval[n] = proceduresForNeedApproval[n] - 1;
          }
        }
      }
      console.log(proceduresForNeedApproval);
    }
    procedures.splice(index, 1);
    /*   const allproceduresRows = procedures.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center">
            <Checkbox
              name="online"
              defaultChecked={
                proceduresForNeedApproval.includes(index + 1) ? true : false
              }
              onChange={(e) => this.handleCheckBox(e, index)}
            />
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.type}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.code}{" "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.quantity}
          </TableCell>

          <TableCell align="center" style={{ fontSize: "small" }}>
            {element.description}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {this.state.showToothNumber ? element.toothDescription : " "}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteProcedure(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    }); */
    this.setState({ /* allproceduresRows, */ procedures });
    if (JSON.stringify(procedures) == "[]") {
      this.setState({ addProceduretotable: false });
    }
  };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "online") {
      if (e.target.checked) {
        this.setState({ elegibilityOnline: true });
      } else {
        this.setState({ elegibilityOnline: false });
      }
    } else if (e.target.name == "offline") {
      if (e.target.checked) {
        this.setState({ elegibilityOffline: true });
      } else {
        this.setState({ elegibilityOffline: false });
      }
    }
    // else if (e.target.name === "package") {
    //   if (e.target.checked) {
    //     this.setState({ packageProcedure: true });
    //   } else {
    //     this.setState({ packageProcedure: false });
    //   }

    // }
  };
  HandleSupportingInfoChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { selectedName } = this.state;
    if(selectedName === "chief-complaint"){
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo:{text:value} },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    }else{
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo:value },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
    });
  }
  };
  handleConfirm = async (e) => {
    e.preventDefault();
    if (this.state.attachmentSelected && !this.state.selectedFile) {
      this.setState({
        fileMsg: "please select a file !",
      });
    } else {
      let {
        supportingInfoarray,
        vitalSignsArray,
        vitalSignJson,
        vitalSignSelectJson,
        vitalSignSelectArray,
      } = this.state;
      this.setState({ vitalSelect: "", vitalValue: "" });
      if (this.state.selectedName === "attachment") {
        const lastModifiedDateStr = vitalSignJson.valueInfo.lastModifiedDate

        const lastModifiedDate = new Date(lastModifiedDateStr)
        const year = lastModifiedDate.getFullYear()
        const month = String(lastModifiedDate.getMonth() + 1).padStart(2, '0')
        const day = String(lastModifiedDate.getDate()).padStart(2, '0')
        const formattedDate = `${year}_${month}_${day}`
        supportingInfoarray.push({
          [vitalSignJson.display]: {
            contentType: vitalSignJson.valueInfo.type,
            title: vitalSignJson.valueInfo.name,
            data: vitalSignJson.data,
            // creation: (vitalSignJson.valueInfo.lastModifiedDate.toString()).split('(')[0].trim()
            creation: formattedDate
          }
        });
      } else {
        supportingInfoarray.push({
          [vitalSignJson.display]: vitalSignJson.valueInfo,
        });
      }

      vitalSignsArray.push(vitalSignJson);
      vitalSignSelectArray.push(vitalSignSelectJson);
      console.log(vitalSignJson, "json");
      console.log(supportingInfoarray, "suporting");
      const allVitalRows = vitalSignsArray.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.display}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
            {element.valueInfo.name
              ? element.valueInfo.name
              : element.valueInfo.text ? element.valueInfo.text:element.valueInfo}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteVital(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
      this.setState({
        allVitalRows,
        addVitaltotable: true,
        vitalSignsArray,
      });
    }
  };
  onSelectDiagnosis = (selectedList) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onRemoveDiagnosis = (selectedList, removedItem) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onSelectCategory = (selectedList) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  onRemoveCategory = (selectedList, removedItem) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  render() {
    let {
      selectedClaim,
      allDiagnosisOptions,
      procedures,
    } = this.state;
     console.log(this.state.addVitaltotable,'vitallll')
     console.log(this.state.allVitalRows,'vitallllRow')
    let total = 0;
    let allproceduresRows = [];
    if (procedures && procedures.length > 0) {
      allproceduresRows = procedures.map((element, index) => {
        let { Net } = element;
        total += Net;
        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.type}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.quantity}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.description}
            </TableCell>

            {this.state.showToothNumber ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {this.state.showToothNumber ? element.toothDescription : " "}
              </TableCell>
            ) : (
              ""
            )}

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.price}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.discount}%
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element["priceAfterDiscount"]}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.tax}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.Net}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteProcedure(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
    }

    return (
      <div>
        <div style={{width:"90%",margin:"10px auto"}}>
            <div style={{width:"100%",margin:"10px auto"}}>
            <Row style={{margin:"10px auto"}}>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.patient_file_number}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="medicalFile"
                    label="Medical File"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.patient_gender}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="gender"
                    label="Gender"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  
                      <InputLabel id="type" style={{ fontSize: "small" }}>
                        Claim Type
                      </InputLabel>
                      <Select
                        required
                        labelId="type"
                        name="claimType"
                        label="Claim Type"
                        onChange={this.HandleInputTextChange}
                        style={{ height: "45px" }}
                        value={this.state.selectedClaim.claim_type}
                      >
                        <MenuItem
                          value="institutional"
                          style={{ fontSize: "small" }}
                        >
                          Institutional
                        </MenuItem>
                        <MenuItem value="oral" style={{ fontSize: "small" }}>
                          Oral
                        </MenuItem>
                        <MenuItem
                          value="pharmacy"
                          style={{ fontSize: "small" }}
                        >
                          Pharmacy
                        </MenuItem>
                        <MenuItem
                          value="professional"
                          style={{ fontSize: "small" }}
                        >
                          Professional
                        </MenuItem>
                        <MenuItem value="vision" style={{ fontSize: "small" }}>
                          Vision
                        </MenuItem>
                      </Select>
                </FormControl>
              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.patient_first_name+" " +selectedClaim.patient_last_name}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="patient"
                    label="Patient Name"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.patient_nationality}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="nationality"
                    label="Nationality"
                    variant="outlined"
                  />
                </FormControl>
              </Col>
              <Col>
                
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.patient_dob}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="birthDate"
                    label="Birth Date"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={selectedClaim.visit_type}
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="visitType"
                    label="Visit Type"
                    variant="outlined"
                  />
                </FormControl>
              </Col>
            </Row>
            </div>
           

            <hr />
            <div style={{ textAlign: "center" }}>
              <Box sx={{ width: "100%" }}>
                
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.vitalSelected ? "lightgrey" : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      diagnosisSelected: false,
                      vitalSelected: true,
                      procedureSelected: false,
                    });
                  }}
                >
                  {"Vital Sign"}
                </Link>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.diagnosisSelected
                      ? "lightgrey"
                      : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      diagnosisSelected: true,
                      vitalSelected: false,
                      procedureSelected: false,
                    });
                  }}
                >
                  {"Diagnosis"}
                </Link>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.procedureSelected
                      ? "lightgrey"
                      : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      procedureSelected: true,
                      diagnosisSelected: false,
                      vitalSelected: false,
                    });
                  }}
                >
                  {"Procedures"}
                </Link>
              </Box>
            </div>

            <hr />
            <div style={{ textAlign: "center", width: "90%", margin: "auto" }}>
              {/* {this.state.selectedClaim &&
                selectedClaim.length > 0 &&
                this.state.diagnosisSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleOpenDiagnosis}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>

                  {this.state.addDiagnosistotable &&
                    this.state.allDiagnosisRows.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              {this.state.claimType === "institutional" ? (
                                <>
                                  <TableCell align="center">
                                    On Admission
                                  </TableCell>
                                </>
                              ) : null}
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Code</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{this.state.allDiagnosisRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null} */}
              {this.state.vitalSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleVitalSignModal}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>

                  {this.state.vitalSelected&&this.state.addVitaltotable ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Vital Sign</TableCell>
                              <TableCell align="center">Value</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{this.state.allVitalRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}

              {/****** **********************************/}
              {this.state.selectedClaim &&
                selectedClaim.length > 0 &&
                this.state.procedureSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleOpenProcedure}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>
                  {this.state.procedures.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              {/*                             <TableCell align="center"></TableCell>
                               */}{" "}
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Code</TableCell>
                              <TableCell align="center">Quantity</TableCell>
                              <TableCell align="center">Description</TableCell>
                              {this.state.showToothNumber ? (
                                <TableCell align="center">
                                  Tooth Number
                                </TableCell>
                              ) : null}
                              <TableCell align="center">Unit Price</TableCell>
                              <TableCell align="center">Discount</TableCell>
                              <TableCell align="center">
                                Price After Discount
                              </TableCell>
                              <TableCell align="center">Tax</TableCell>
                              <TableCell align="center">Net</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{allproceduresRows}</TableBody>
                        </Table>
                      </TableContainer>
                      <h5>Total:{total} SAR</h5>
                    </>
                  ) : null}
                </>
              ) : null}
              {/************************************** */}
             
              {this.state.diagnosisModal ? (
                <>
                  <Modal
                    open={this.state.diagnosisModal}
                    onClose={this.handleCloseDiagnosis}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box sx={styleModal} style={{ width: "30%" }}>
                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        <FormControl sx={{ mb: 3, width: "70%" }}>
                          <InputLabel
                            id="typeLabel"
                            style={{ fontSize: "small" }}
                          >
                            Type
                          </InputLabel>
                          <Select
                            style={{ height: "45px" }}
                            required
                            labelId="typeLabel"
                            name="type"
                            label="Type"
                            value={this.state.diagnosisType}
                            onChange={this.HandleDiagnosisChange}
                          >
                            <MenuItem
                              value="principal"
                              style={{ fontSize: "small" }}
                            >
                              Principal
                            </MenuItem>
                            <MenuItem
                              value="secondary"
                              style={{ fontSize: "small" }}
                            >
                              Secondary
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        {this.state.allDiagnosisOptions &&
                          allDiagnosisOptions.length > 0 ? (
                          <>
                            <FormControl sx={{ mb: 3, width: "70%" }}>
                              <Autocomplete
                                suggestions={this.state.allDiagnosisOptions}
                                onChangeSetCode={this.handleDiagnosisSelect}
                                flag={this.state.autoCompleteValue}
                              />
                            </FormControl>
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                marginTop: "10px",
                              }}
                            >
                              <Spinner animation="border" variant="success" />
                            </div>
                          </>
                        )}
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "rgb(97 110 120",
                            width: "95px",
                          }}
                          onClick={(e) => this.handleSubmitAddNewDiagnosis(e)}
                        >
                          Add
                        </Button>
                      </div>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.vitalModal ? (
                <>
                  <Modal
                    open={this.state.vitalModal}
                    onClose={this.handleCloseVital}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box sx={styleModal} style={{ width: "30%" }}>
                      <div style={{ textAlign: "center" }}>
                        <FormControl style={{ width: "70%" }} sx={{ mb: 3 }}>
                          <InputLabel
                            id="category"
                            style={{ fontSize: "small" }}
                          >
                            Vital Sign
                          </InputLabel>
                          <Select
                            labelId="supportingInformation"
                            name="category"
                            label="supportingInformation"
                            onChange={this.HandleVitalSignChange}
                            value={this.state.vitalSelect}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="vital-sign-diastolic"
                              style={{ fontSize: "small" }}
                            >
                              Diastolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-systolic"
                              style={{ fontSize: "small" }}
                            >
                              Systolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-height"
                              style={{ fontSize: "small" }}
                            >
                              Height
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-weight"
                              style={{ fontSize: "small" }}
                            >
                              Weight
                            </MenuItem>
                            <MenuItem
                              value="days-supply"
                              style={{ fontSize: "small" }}
                            >
                              Days supply
                            </MenuItem>
                            <MenuItem
                              value="temperature"
                              style={{ fontSize: "small" }}
                            >
                              Temperature
                            </MenuItem>

                            <MenuItem
                              value="pulse"
                              style={{ fontSize: "small" }}
                            >
                              Pulse
                            </MenuItem>

                            <MenuItem
                              value="respiratory-rate"
                              style={{ fontSize: "small" }}
                            >
                              Respiratory Rate
                            </MenuItem>

                            <MenuItem
                              value="chief-complaint"
                              style={{ fontSize: "small" }}
                            >
                              Chief Complaint
                            </MenuItem>
                            <MenuItem
                              value="birth-weight"
                              style={{ fontSize: "small" }}
                            >
                              Birth weight
                            </MenuItem>
                            <MenuItem
                              value="attachment"
                              style={{ fontSize: "small" }}
                            >
                              Attachment
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      {this.state.chiefComplainSelected ? (
                        <>
                        <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="text"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : this.state.attachmentSelected ? (
                        <>
                          <input
                            style={{
                              display: "block",
                              margin: "auto",
                              marginRight: "5px",
                            }}
                            type="file"
                            onChange={this.onFileChange}
                          />
                          {this.state.fileMsg ? (
                            <>
                              <div style={{ textAlign: "center" }}>
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "10px",
                                  }}
                                >
                                  {this.state.fileMsg}
                                </span>
                              </div>
                            </>
                          ) : null}
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                                marginTop: "20px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : this.state.vitalSignSelected ? (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="number"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : null}
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.procedureModal ? (
                <>
                  <Modal
                    open={this.state.procedureModal}
                    onClose={this.handleCloseProcedure}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={styleModal}
                      style={{
                        width: "40%",
                        height: "70%",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <FormControl
                          /*  style={{ width: "216.4px" }} */
                          style={{ width: "65%", margin: "10px auto" }}
                          sx={{ mb: 3 }}
                        >
                          <InputLabel
                            id="service type"
                            style={{ fontSize: "small" }}
                          >
                            Service Type
                          </InputLabel>
                          <Select
                            required
                            fullWidth
                            style={{ height: "45px" }}
                            labelId="service type"
                            name="type"
                            label="Service Type"
                            value={this.state.serviceValue}
                            onChange={this.HandleProcedureChange}
                          >
                            <MenuItem
                              value="consultation"
                              style={{ fontSize: "small" }}
                            >
                              Consultation
                            </MenuItem>
                            <MenuItem
                              value="dental"
                              style={{ fontSize: "small" }}
                            >
                              Dental
                            </MenuItem>{" "}
                            <MenuItem
                              value="laboratory"
                              style={{ fontSize: "small" }}
                            >
                              Laboratory
                            </MenuItem>{" "}
                            <MenuItem
                              value="medication"
                              style={{ fontSize: "small" }}
                            >
                              Medication
                            </MenuItem>{" "}
                            <MenuItem
                              value="procedure"
                              style={{ fontSize: "small" }}
                            >
                              Procedure
                            </MenuItem>
                            <MenuItem
                              value="radiology"
                              style={{ fontSize: "small" }}
                            >
                              Radiology
                            </MenuItem>
                          </Select>
                        </FormControl>

                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: "10px auto" }}
                        >
                          <TextField
                            // InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureCode}
                            /*  inputProps={{ sx: { padding: "11px" } }} */

                            required
                            name="code"
                            label="Code"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>

                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: "10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureDescription}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            name="description"
                            label="Description"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>

                        {this.state.showToothNumber ? (
                          <>
                            <FormControl
                              fullWidth
                              sx={{ mb: 3 }}
                              style={{ width: "65%", margin: "10px auto" }}
                            >
                              <InputLabel
                                id="toothnumber"
                                style={{ fontSize: "small" }}
                              >
                                Tooth Number
                              </InputLabel>
                              <Select
                                required
                                labelId="toothnumber"
                                name="toothNumber"
                                label="Tooth Number"
                                style={{ height: "45px" }}
                                value={this.state.toothNumberValue}
                                onChange={this.HandleProcedureChange}
                              >
                                <MenuItem
                                  value="11-UPPER RIGHT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  11-UPPER RIGHT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="12-UPPER RIGHT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  12-UPPER RIGHT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="13-UPPER RIGHT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  13-UPPER RIGHT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="14-UPPER RIGHT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  14-UPPER RIGHT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="15-UPPER RIGHT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  15-UPPER RIGHT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="16-UPPER RIGHT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  16-UPPER RIGHT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="17-UPPER RIGHT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  17-UPPER RIGHT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="18-UPPER RIGHT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  18-UPPER RIGHT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="21-UPPER LEFT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  21-UPPER LEFT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="22-UPPER LEFT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  22-UPPER LEFT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="23-UPPER LEFT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  23-UPPER LEFT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="24-UPPER LEFT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  24-UPPER LEFT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="25-UPPER LEFT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  25-UPPER LEFT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="26-UPPER LEFT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  26-UPPER LEFT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="27-UPPER LEFT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  27-UPPER LEFT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="28-UPPER LEFT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  28-UPPER LEFT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="31-LOWER LEFT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  31-LOWER LEFT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="32-LOWER LEFT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  32-LOWER LEFT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="33-LOWER LEFT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  33-LOWER LEFT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="34-LOWER LEFT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  34-LOWER LEFT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="35-LOWER LEFT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  35-LOWER LEFT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="36-LOWER LEFT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  36-LOWER LEFT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="37-LOWER LEFT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  37-LOWER LEFT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="38-LOWER LEFT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  38-LOWER LEFT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="41-LOWER RIGHT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  41-LOWER RIGHT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="42-LOWER RIGHT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  42-LOWER RIGHT; PERMANENT TEETH # 2"
                                </MenuItem>
                                <MenuItem
                                  value="43-LOWER RIGHT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  43-LOWER RIGHT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="44-LOWER RIGHT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  44-LOWER RIGHT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="45-LOWER RIGHT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  45-LOWER RIGHT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="46-LOWER RIGHT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  46-LOWER RIGHT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="47-LOWER RIGHT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  47-LOWER RIGHT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="48-LOWER RIGHT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  48-LOWER RIGHT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="51-UPPER RIGHT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  51-UPPER RIGHT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="52-UPPER RIGHT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  52-UPPER RIGHT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="53-UPPER RIGHT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  53-UPPER RIGHT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="54-UPPER RIGHT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  54-UPPER RIGHT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="55-UPPER RIGHT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  55-UPPER RIGHT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="61-UPPER LEFT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  61-UPPER LEFT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="62-UPPER LEFT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  62-UPPER LEFT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="63-UPPER LEFT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  63-UPPER LEFT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="64-UPPER LEFT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  64-UPPER LEFT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="65-UPPER LEFT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  65-UPPER LEFT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="71-LOWER LEFT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  71-LOWER LEFT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="72-LOWER LEFT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  72-LOWER LEFT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="73-LOWER LEFT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  73-LOWER LEFT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="74-LOWER LEFT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  74-LOWER LEFT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="75-LOWER LEFT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  75-LOWER LEFT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="81-LOWER RIGHT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  81-LOWER RIGHT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="82-LOWER RIGHT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  82-LOWER RIGHT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="83-LOWER RIGHT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  83-LOWER RIGHT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="84-LOWER RIGHT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  84-LOWER RIGHT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="85-LOWER RIGHT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  85-LOWER RIGHT; DECIDUOUS TEETH # 5
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        ) : null}

                        {this.state.pharmacistSelection ? (
                          <>
                            <FormControl
                              fullWidth
                              sx={{ mb: 3 }}
                              style={{ width: "65%", margin: "10px auto" }}
                            >
                              <InputLabel
                                id="pharmacistSelectionReason"
                                style={{ fontSize: "small" }}
                              >
                                Pharmacist Selection Reason
                              </InputLabel>
                              <Select
                                required
                                labelId="pharmacistSelectionReason"
                                name="pharmacistSelectionReason"
                                label="Pharmacist Selection Reason"
                                style={{ height: "45px" }}
                                value={this.state.pharmacistSelectionReasonValue}
                                onChange={this.HandleProcedureChange}
                              >
                                <MenuItem
                                  value="Generic"
                                  style={{ fontSize: "small" }}
                                >
                                  Generic drug
                                </MenuItem>
                                <MenuItem
                                  value="patient-request"
                                  style={{ fontSize: "small" }}
                                >
                                  dispensed as per patient's request
                                </MenuItem>
                                <MenuItem
                                  value="innovative-noGeneric"
                                  style={{ fontSize: "small" }}
                                >
                                  innovative drug with noGeneric
                                </MenuItem>
                                <MenuItem
                                  value="physician-approval"
                                  style={{ fontSize: "small" }}
                                >
                                  dispensed as per physician-request with approval
                                </MenuItem>
                                <MenuItem
                                  value="physician-no-approval"
                                  style={{ fontSize: "small" }}
                                >
                                  physician-request without approval
                                </MenuItem>
                                <MenuItem
                                  value="drug-pharmacyUnavailable"
                                  style={{ fontSize: "small" }}
                                >
                                  drug-pharmacyUnavailable
                                </MenuItem>
                                <MenuItem
                                  value="drugnationallyUnavailable"
                                  style={{ fontSize: "small" }}
                                >
                                  Generic drug
                                </MenuItem>
                                <MenuItem
                                  value="dIrreplaceable"
                                  style={{ fontSize: "small" }}
                                >
                                  dispensed as per patient's request
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        ) : null}
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureQuantity}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            type="number"
                            name="quantity"
                            label="Quantity"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedurePrice}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            type="number"
                            name="price"
                            label="Price"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureDiscount}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            type="number"
                            name="discount"
                            label="Discount"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureShare}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            type="number"
                            name="patientshare_total"
                            label="Patientshare"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={this.state.procedureTax}
                            inputProps={{ sx: { padding: "11px" } }}
                            required
                            type="number"
                            name="tax_percentage"
                            label="Tax"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        {this.state.attachmentFlag ? (
                          <>
                            <input
                              style={{
                                display: "block",
                                margin: "auto",
                                marginLeft: "164px"
                              }}
                              type="file"
                              onChange={this.onFileChange}
                            />
                            {this.state.fileMsg ? (
                              <>
                                <div style={{ textAlign: "center" }}>
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "10px",
                                    }}
                                  >
                                    {this.state.fileMsg}
                                  </span>
                                </div>
                              </>
                            ) : null}
                            <div style={{ textAlign: "center", width: "40%", margin: "auto" }}>
                              <Button
                                variant="contained"
                                style={{
                                  backgroundColor: "rgb(97 110 120",

                                  marginTop: "20px",
                                }}
                                onClick={(e) => this.handleConfirm(e)}
                              >
                                Add Attachment
                              </Button>
                            </div>
                          </>

                        ) : null}
                        {this.state.vitalSignsArray &&
                          this.state.vitalSignsArray.length > 0 ? (
                          <div style={{ width: "65% ", margin: "10px auto" }}>
                            <Multiselect
                              placeholder="Supporting Informatiom"
                              options={this.state.vitalSignSelectArray}
                              onSelect={this.onSelectCategory}
                              onRemove={this.onRemoveCategory}
                              displayValue="display"
                            />
                          </div>
                        ) : null}
                        {this.state.allDiagnosis &&
                          this.state.allDiagnosis.length > 0 ? (
                          <div
                            style={{
                              width: "65%",
                              margin: "10px auto",
                              /*  marginTop: "20px", */
                            }}
                          >
                            <Multiselect
                              placeholder="Diagnosis"
                              options={this.state.allDiagnosisSelect}
                              // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                              onSelect={this.onSelectDiagnosis}
                              onRemove={this.onRemoveDiagnosis}
                              displayValue="view"
                            />
                          </div>
                        ) : null}
                       
                      </div>

                      <div style={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          style={{
                            marginTop: "30px",
                            backgroundColor: "rgb(97 110 120",
                            width: "100px",
                          }}
                          onClick={(e) => this.handleSubmitAddNewProcedure(e)}
                        >
                          Add
                        </Button>
                      </div>
                      
                    </Box>
                  </Modal>
                </>
              ) : null}
            </div>
        
        </div>
      </div>
    );
  }
}

export default EditClaimInfo;
